import { render, staticRenderFns } from "./ProjectCreateModel.vue?vue&type=template&id=2d397283&scoped=true"
import script from "./ProjectCreateModel.vue?vue&type=script&lang=js"
export * from "./ProjectCreateModel.vue?vue&type=script&lang=js"
import style0 from "./ProjectCreateModel.vue?vue&type=style&index=0&id=2d397283&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d397283",
  null
  
)

export default component.exports